module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?1d7bcee1b302339c3b8db10214dc9ec6";